import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { TokenStorageService } from '../auth/token-storage.service';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) =>
{
  const tokenStorage = inject(TokenStorageService);
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) =>
    {
      if (error instanceof HttpErrorResponse && error.status === 401)
      {
        const preferredSlug = authService.getPreferredCompanySlug();

        tokenStorage.clear();

        if (preferredSlug)
        {
          void router.navigate(['/', preferredSlug, 'login']);
        }
        else
        {
          void router.navigate(['/login']);
        }
      }

      return throwError(() => error);
    })
  );
};
